import React, { useState } from "react";

import api, { handleApi } from "pages/api/api";

import DialogSelecionarMateriais from "./DialogSelecionarMateriais";

import createAutocompleteFilter from "pages/utils/autocompleteFilter";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

const materialFilter = createAutocompleteFilter(
  (option) => `${option?.ref ?? ""} ${option?.nome ?? ""}`
);

export default function DialogCampanhaMaterialAlternativas({
  PaperComponent,
  open,
  onClose,
  materialAlternativasSelecionado,
  formAlternativa,
  setFormAlternativa,
  alternativaInput,
  setAlternativaInput,
  materiaisCombo,
  carregarMateriaisCombo,
  materialLabel,
  alternativasPorMaterial,
  guardarAlternativa,
  form,
  carregarAlternativasMaterial,
  showAlert,
  setLoading,
}) {
  const [openSelecionarMateriais, setOpenSelecionarMateriais] = useState(false);

  const confirmarSelecionarAlternativas = async (materiais) => {
    if (!materialAlternativasSelecionado?.id) {
      showAlert("Seleciona primeiro o material principal.", "warning");
      return;
    }

    if (!materiais || materiais.length === 0) {
      showAlert("Seleciona pelo menos um material.", "warning");
      return;
    }

    setLoading(true);

    const [payload, err, meta] = await handleApi(
      api.post("Campanhas/InsCampanhaMaterialAlternativosLote", {
        idcampanhamaterial: materialAlternativasSelecionado.id,
        refmaterialprincipal: materialAlternativasSelecionado.refmaterial,
        materiais: materiais.map((m) => ({
          refmaterialalternativo: m.ref,
          qtd: Number(formAlternativa.qtd || 0),
          unidade: m.refmaterialunidade || formAlternativa.unidade || "",
          descprommaxfabricante:
            formAlternativa.descprommaxfabricante === ""
              ? null
              : Number(formAlternativa.descprommaxfabricante),
          fatorequivalencia: Number(formAlternativa.fatorequivalencia || 1),
          obs: formAlternativa.obs || "",
        })),
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setOpenSelecionarMateriais(false);

    await carregarAlternativasMaterial(materialAlternativasSelecionado.id);

    onClose();

    showAlert(meta?.message || "Alternativas inseridas.", meta?.severity || "success");
  };

  return (
    <Dialog
      PaperComponent={PaperComponent}
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", md: "900px" },
          maxWidth: "100%",
          m: { xs: 1.5, md: 3 },
        },
      }}
    >
      <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
        Alternativas —{" "}
        {materialAlternativasSelecionado?.material ||
          materialAlternativasSelecionado?.refmaterial ||
          ""}
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 1.5, md: 3 },
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <MDBox display="grid" gap={2} mt={1}>
          <MDBox
            p={{ xs: 1.25, md: 2 }}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              maxWidth: "100%",
              overflowX: "auto",
            }}
          >
            <MDTypography variant="h6" mb={1}>
              Nova / editar alternativa
            </MDTypography>

            <MDTypography
              variant="caption"
              color="text"
              sx={{ display: "block", mb: 2, lineHeight: 1.6 }}
            >
              Se indicar <strong>0</strong> na quantidade, qualquer quantidade encontrada nesta
              alternativa será somada ao material principal. Se indicar um valor superior a{" "}
              <strong>0</strong> (ex: 2), esta alternativa só será considerada se a fatura tiver
              pelo menos essa quantidade.
            </MDTypography>

            <MDBox display="flex" gap={1} mb={1.5} flexWrap="wrap">
              <MDButton color="info" onClick={() => setOpenSelecionarMateriais(true)}>
                Selecionar vários
              </MDButton>
            </MDBox>

            <MDBox
              display="grid"
              gridTemplateColumns={{
                xs: "1fr",
                sm: "1fr 1fr",
                lg: "2fr 0.7fr 0.7fr 1fr 0.9fr 2fr",
              }}
              gap={1}
            >
              <Autocomplete
                size="small"
                options={materiaisCombo.filter(
                  (m) =>
                    m.ref !== materialAlternativasSelecionado?.refmaterial &&
                    !(alternativasPorMaterial[materialAlternativasSelecionado?.id] || []).some(
                      (a) => a.refmaterialalternativo === m.ref
                    )
                )}
                filterOptions={materialFilter}
                inputValue={alternativaInput}
                getOptionLabel={materialLabel}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      color: Number(option.inativo || 0) === 1 ? "#d32f2f" : undefined,
                      fontWeight: Number(option.inativo || 0) === 1 ? "bold" : undefined,
                    }}
                  >
                    {materialLabel(option)}
                  </li>
                )}
                value={
                  materiaisCombo.find((m) => m.ref === formAlternativa.refmaterialalternativo) ||
                  null
                }
                onInputChange={(_, value, reason) => {
                  if (reason === "input") {
                    setAlternativaInput(value);
                    setFormAlternativa((p) => ({ ...p, refmaterialalternativo: "" }));
                    carregarMateriaisCombo(value);
                  }

                  if (reason === "clear") {
                    setAlternativaInput("");
                    setFormAlternativa((p) => ({ ...p, refmaterialalternativo: "" }));
                  }
                }}
                onChange={(_, value) => {
                  setFormAlternativa((p) => ({
                    ...p,
                    refmaterialalternativo: value?.ref || "",
                    unidade: value?.refmaterialunidade || p.unidade,
                  }));

                  setAlternativaInput(value ? materialLabel(value) : "");
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Material alternativo" placeholder="Pesquisar..." />
                )}
              />

              <MDInput
                label="Qtd"
                type="number"
                value={formAlternativa.qtd}
                onChange={(e) => setFormAlternativa((p) => ({ ...p, qtd: e.target.value }))}
                fullWidth
              />

              <MDInput
                label="Unid."
                value={formAlternativa.unidade}
                onChange={(e) => setFormAlternativa((p) => ({ ...p, unidade: e.target.value }))}
                fullWidth
              />

              <MDInput
                label="Fator equiv."
                type="number"
                inputProps={{ step: "0.001", min: "0.001" }}
                value={formAlternativa.fatorequivalencia}
                onChange={(e) =>
                  setFormAlternativa((p) => ({
                    ...p,
                    fatorequivalencia: e.target.value,
                  }))
                }
                fullWidth
              />

              <MDInput
                label="Desc. máx. fab. (%)"
                type="number"
                value={formAlternativa.descprommaxfabricante}
                onChange={(e) =>
                  setFormAlternativa((p) => ({
                    ...p,
                    descprommaxfabricante: e.target.value,
                  }))
                }
                fullWidth
              />

              <MDInput
                label="Obs"
                value={formAlternativa.obs}
                onChange={(e) => setFormAlternativa((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
              />
            </MDBox>
          </MDBox>
        </MDBox>
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: "wrap",
          gap: 1,
          px: { xs: 2, md: 3 },
          pb: { xs: 2, md: 2 },
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>

        <MDButton color="success" onClick={guardarAlternativa}>
          {formAlternativa.id ? "Atualizar" : "Adicionar"}
        </MDButton>
      </DialogActions>

      <DialogSelecionarMateriais
        open={openSelecionarMateriais}
        onClose={() => setOpenSelecionarMateriais(false)}
        materiaisCombo={materiaisCombo.filter(
          (m) =>
            m.ref !== materialAlternativasSelecionado?.refmaterial &&
            !(alternativasPorMaterial[materialAlternativasSelecionado?.id] || []).some(
              (a) => a.refmaterialalternativo === m.ref
            )
        )}
        carregarMateriaisCombo={carregarMateriaisCombo}
        materialLabel={materialLabel}
        onConfirmar={confirmarSelecionarAlternativas}
      />
    </Dialog>
  );
}
